import { useEffect } from 'react';

const ContentProtection = ({ user }) => {
  useEffect(() => {
    // Only apply protection if user is not admin
    const isAdmin = user?.email === 'shifracs@gmail.com';
    
    if (isAdmin) {
      return; // Don't apply any protection for admin
    }

    // Check if current page should be protected
    const isProtectedPage = () => {
      const path = window.location.pathname;
      // Protect ONLY exam-related pages
      const protectedPaths = [
        '/exam-bank',
        '/dentist-exam-bank',
        '/pharmacy-exam-bank',
        '/engineering-exam-bank',
        '/global-exam-bank',
        '/free-trial-exams'
      ];
      return protectedPaths.some(p => path.startsWith(p));
    };

    // Apply text selection disable ONLY on exam pages
    if (isProtectedPage()) {
      document.body.style.userSelect = 'none';
      document.body.style.webkitUserSelect = 'none';
      document.body.style.mozUserSelect = 'none';
      document.body.style.msUserSelect = 'none';
    } else {
      // Enable text selection on non-exam pages
      document.body.style.userSelect = 'text';
      document.body.style.webkitUserSelect = 'text';
      document.body.style.mozUserSelect = 'text';
      document.body.style.msUserSelect = 'text';
    }

    // Disable right-click only on protected pages
    const handleContextMenu = (e) => {
      if (isProtectedPage()) {
        e.preventDefault();
        return false;
      }
    };

    // Disable copy, cut, and select all only on protected pages
    const handleKeyDown = (e) => {
      if (isProtectedPage()) {
        // Disable Ctrl+C, Ctrl+X, Ctrl+A, Ctrl+U, F12
        if (
          (e.ctrlKey && (e.key === 'c' || e.key === 'x' || e.key === 'a' || e.key === 'u')) ||
          (e.metaKey && (e.key === 'c' || e.key === 'x' || e.key === 'a' || e.key === 'u')) ||
          e.key === 'F12'
        ) {
          e.preventDefault();
          return false;
        }
      }
    };

    // Add event listeners
    document.addEventListener('contextmenu', handleContextMenu);
    document.addEventListener('keydown', handleKeyDown);

    // Cleanup function
    return () => {
      document.removeEventListener('contextmenu', handleContextMenu);
      document.removeEventListener('keydown', handleKeyDown);
      // Reset text selection to default (enabled)
      document.body.style.userSelect = 'text';
      document.body.style.webkitUserSelect = 'text';
      document.body.style.mozUserSelect = 'text';
      document.body.style.msUserSelect = 'text';
    };
  }, [user]);

  return null; // This component doesn't render anything
};

export default ContentProtection;
